import { AnyAction } from "redux"
import { TOAST_CLEAR, TOAST_ERROR, TOAST_SUCCESS } from "./toast-actions"

interface ToastState {
  error: boolean
  success: boolean
  message: string
}

const INITIAL_STATE: ToastState = {
  error: false,
  success: false,
  message: ""
}

export default function toastReducer(state: ToastState = INITIAL_STATE, action: AnyAction) {
  switch (action.type) {
    case TOAST_ERROR:
      return {
        ...state,
        error: true,
        message: action.payload.message as string
      }

    case TOAST_SUCCESS:
      return {
        ...state,
        success: true,
        message: action.payload.message as string
      }

    case TOAST_CLEAR:
      return INITIAL_STATE

    default:
      return state
  }
}
